// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.free-apartments {
    box-shadow: 1px 1px 13px 0 #10101036;
    text-align: center;
    padding: 30px;
    background-color: #FFFFFF;
    color: #000000;
}

.free-apartments button {
    width: 80%;
}

.free-apartments .counter {
    font-size: 80px;
    display: block;
    height: 100px;
    line-height: 100px;
    font-family: "Times New Roman", sans-serif;
}

`, "",{"version":3,"sources":["webpack://./src/components/rental/free-apartments.css"],"names":[],"mappings":";AACA;IACI,oCAAoC;IACpC,kBAAkB;IAClB,aAAa;IACb,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,eAAe;IACf,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,0CAA0C;AAC9C","sourcesContent":["\n.free-apartments {\n    box-shadow: 1px 1px 13px 0 #10101036;\n    text-align: center;\n    padding: 30px;\n    background-color: #FFFFFF;\n    color: #000000;\n}\n\n.free-apartments button {\n    width: 80%;\n}\n\n.free-apartments .counter {\n    font-size: 80px;\n    display: block;\n    height: 100px;\n    line-height: 100px;\n    font-family: \"Times New Roman\", sans-serif;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
